module.exports = __webpack_public_path__ + "assets/img/5443a59c77d6837dbe3db4c37aead1a7.png";